import script from "./theme-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./theme-menu.vue?vue&type=script&setup=true&lang=ts"

import "./theme-menu.vue?vue&type=style&index=0&id=6a0e12b6&lang=scss"

const __exports__ = script;

export default __exports__